<template>
  <div class="verify">
    <Header class="header" v-if="showHeader">
      <Menu mode="horizontal" theme="dark" active-name="1" class="top-bar">
        <div class="layout-logo">
          <img src="./../../assets/logo.png" height="42" style="margin-right:10px;">
          <div class="site-name-area">
            <h2 class="inline font-white">{{getConfig('TITLE')}}</h2>
            <div class="small font-grey">{{getConfig('SUBTITLE')}}</div>
          </div>
        </div>
        <div class="layout-nav">
        </div>
        <div class="pull-right" style="margin-right:20px">
          <Tooltip content="登录系统">
            <Button type="text" ghost @click="$router.push('/welcome')" icon="md-exit">登录系统</Button>
          </Tooltip>
        </div>
      </Menu>
    </Header>
    <Row>
      <i-col span="16" offset="4">
        <Form ref="verifyForm"
          label-position="left"
          :label-width="0">
          <div class="padding-top-20"></div><div class="padding-top-20"></div>
          <FormItem label="" style="width:100%">
            <Input size="large" v-model="code" search enter-button="验真" @on-search="verify" :placeholder="`输入${verifyMethod==='code'?'保函验真码':'保函编号'}`">
              <Select v-model="verifyMethod" slot="prepend" style="width: 160px">
                <Option value="code">保函验真码</Option>
                <Option value="orderNumber">保函编号</Option>
              </Select>
            </Input>
          </FormItem>
          <Alert type="info" show-icon v-if="verifyMethod==='code'">
            保函查询码是一组字符串，包括数字与字母<br>您可在电子保函中找到它，填写在上面
            <span slot="desc">
              例：JO-SBM-3B6-UIL
            </span>
          </Alert>
          <!-- <div class="padding-top-20"></div><div class="padding-top-20"></div>
          <Button type="primary" size="large" long @click="verify" :disabled="loading">验真</Button> -->
        </Form>
      </i-col>
    </Row>
    <div class="padding-top-20"></div>
    <Row>
      <i-col span="16" offset="4">
        <Alert type="error" show-icon v-if="showErr&&code">
          {{errMsg}}
          <span slot="desc">
            请检查您输入的保函查询码，或联系承保人
          </span>
        </Alert>
        <Alert type="success" show-icon v-if="guaranteeModel&&code">
          查询到保函  {{guaranteeModel.orderNumber}}
          <span slot="desc">
            请核对以下信息
          </span>
        </Alert>
        <div class="detail-body">
          <Tabs type="card" class="tab-square" :animated="false" v-if="guaranteeModel&&guaranteeModel.orderNumber">
            <TabPane label="基本信息" name="basic">
              <Divider>基本属性</Divider>
              <table class="brief-table">
                <tbody>
                  <tr>
                    <td class="title">地区</td>
                    <td>{{guaranteeModel.cityName}}</td>
                    <td class="title">行业/领域</td>
                    <td>{{guaranteeModel.industry?guaranteeModel.industry.name:'-'}}</td>
                    <td class="title">担保种类</td>
                    <td>{{guaranteeModel.varietyName}}</td>
                  </tr>
                  <tr>
                    <td class="title">{{guaranteeModel.gMethod===2?'主':''}}保证人</td>
                    <td colspan="3">{{guaranteeModel.guarantor?guaranteeModel.guarantor.name:'-'}}</td>
                    <td class="title">社会信用代码</td>
                    <td>{{guaranteeModel.guarantor?guaranteeModel.guarantor.businessLicense:'-'}}</td>
                  </tr>
                  <tr>
                    <td class="title">受益人</td>
                    <td colspan="3">{{guaranteeModel.beneficiary}}</td>
                    <td class="title">社会信用代码</td>
                    <td>{{guaranteeModel.beneficiaryBusinessLicense}}</td>
                  </tr>
                  <tr>
                    <td class="title">被保证人</td>
                    <td colspan="3">{{guaranteeModel.guaranteed}}</td>
                    <td class="title">社会信用代码</td>
                    <td>{{guaranteeModel.guaranteedBusinessLicense}}</td>
                  </tr>
                  <tr v-if="guaranteeModel.gMethod===2">
                    <td class="title">保证方式</td>
                    <td>{{guaranteeModel.gMethod===0?'独立保证':'联合保证'}}</td>
                    <td class="title">联保方案</td>
                    <td colspan="3">
                      <ul class="joint-plan">
                        <li>主承：{{guaranteeModel.guarantor.name}}，{{`¥ ${guaranteeModel.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元</li>
                        <li v-for="(j,idx) in guaranteeModel.jointGuarantors" :key="idx">
                          联保{{idx+1}}：{{j.guarantor.name}}，{{`¥ ${j.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr v-if="guaranteeModel.gMethod===2">
                    <td class="title">总担保金额</td>
                    <td>{{`¥ ${totalGuaAmount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(totalGuaAmount/100)}})</td>
                    <td class="title">担保费率</td>
                    <td>{{guaranteeModel.gFeeRate>0?Math.round(guaranteeModel.gFeeRate*100)/100+'%':''}}</td>
                    <td class="title">保额造价比</td>
                    <td>{{Math.round(totalGuaAmount/guaranteeModel.project.cost*10000)/100}}%</td>
                  </tr>
                  <tr v-if="guaranteeModel.gMethod===0">
                    <td class="title">担保金额</td>
                    <td>{{`¥ ${guaranteeModel.amount/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(guaranteeModel.amount/100)}})</td>
                    <td class="title">担保费率</td>
                    <td>{{guaranteeModel.gFeeRate>0?Math.round(guaranteeModel.gFeeRate*100)/100+'%':''}}</td>
                    <td class="title">保额造价比</td>
                    <td>{{Math.round(guaranteeModel.amountCostRatio*10000)/100}}%</td>
                  </tr>
                  <tr>
                    <td class="title">保函生效时间</td>
                    <td>
                      {{require('moment')(guaranteeModel.gStartDate).format('YYYY-MM-DD HH:mm:ss')}}
                    </td>
                    <td class="title">保函截止时间</td>
                    <td>
                      {{require('moment')(guaranteeModel.gEndDate).format('YYYY-MM-DD HH:mm:ss')}}
                    </td>
                    <td class="title">保证期天数</td>
                    <td>{{require('moment')(guaranteeModel.gEndDate).diff(require('moment')(guaranteeModel.gStartDate), 'days')}}天</td>
                  </tr>
                  <tr>
                    <td class="title">上报人</td>
                    <td>{{guaranteeModel.opName}}({{guaranteeModel.opContactTel}})</td>
                    <td class="title">最后修改</td>
                    <td>{{require('moment')(guaranteeModel.updateTime).format('YYYY-MM-DD HH:mm:ss')}}</td>
                    <td class="title">录入时间</td>
                    <td>{{require('moment')(guaranteeModel.createTime).format('YYYY-MM-DD HH:mm:ss')}}</td>
                  </tr>
                  <tr v-if="[1, 2, 3, 4, 5].indexOf(guaranteeModel.status)>-1">
                    <td class="title">审核人</td>
                    <td>{{guaranteeModel.auditorName}}</td>
                    <td class="title">审核时间</td>
                    <td :colspan="[3, 4, 5].indexOf(guaranteeModel.status)<0?1:3">{{guaranteeModel.auditTime?require('moment')(guaranteeModel.auditTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
                    <td class="title" v-if="[3, 4, 5].indexOf(guaranteeModel.status)<0">终止时间</td>
                    <td v-if="[3, 4, 5].indexOf(guaranteeModel.status)<0">{{guaranteeModel.terminateTime?require('moment')(guaranteeModel.terminateTime).format('YYYY-MM-DD HH:mm:ss'):''}}</td>
                  </tr>
                  <tr v-if="guaranteeModel.terminateReason">
                    <td class="title">解除保函的原因</td>
                    <td colspan="5">{{guaranteeModel.terminateReason}}</td>
                  </tr>
                  <tr v-if="guaranteeModel.auditReason">
                    <td class="title">拒绝的原因</td>
                    <td colspan="5">{{guaranteeModel.auditReason}}</td>
                  </tr>
                </tbody>
              </table>
            </TabPane>
            <TabPane label="项目信息" name="project" v-if="guaranteeModel.project">
              <Divider>项目详情</Divider>
              <table class="brief-table">
                <tbody>
                  <tr>
                    <td class="title">项目名称</td>
                    <td colspan="3">{{guaranteeModel.project.name}}</td>
                    <td class="title">项目类型</td>
                    <td>{{getPrjType(guaranteeModel.project.type).join('/')}}</td>
                  </tr>
                  <tr>
                    <td class="title">项目立项备案号</td>
                    <td>{{guaranteeModel.project.filingNo||'-'}}</td>
                    <td class="title">规划许可证号</td>
                    <td>{{guaranteeModel.project.planLicenseNo||'-'}}</td>
                    <td class="title">施工许可证号</td>
                    <td>{{guaranteeModel.project.constrLicenceNo||'-'}}</td>
                  </tr>
                  <tr>
                    <td class="title">工程造价</td>
                    <td>{{`¥ ${guaranteeModel.project.cost/100}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元({{$common.transformNumberIntoCHS(guaranteeModel.project.cost/100)}})</td>
                    <td class="title">建设规模</td>
                    <td>{{guaranteeModel.project.area||'-'}}</td>
                    <td class="title">计划工期</td>
                    <td>
                      {{guaranteeModel.project.startdate?require('moment')(guaranteeModel.project.startdate).format('YYYY/MM/DD'):null}}
                      -
                      {{guaranteeModel.project.finishdate?require('moment')(guaranteeModel.project.finishdate).format('YYYY/MM/DD'):null}}
                      <span v-if="guaranteeModel.project.startdate&&guaranteeModel.project.finishdate">({{guaranteeModel.project.duration}}天)</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="title">质量要求</td>
                    <td colspan="5">{{guaranteeModel.project.qualityRequirement||'-'}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="padding-top-20"></div>
              <Divider>业主详情</Divider>
              <table class="brief-table">
                <tbody>
                  <tr>
                    <td class="title">业主名称</td>
                    <td colspan="3">{{guaranteeModel.owner?guaranteeModel.owner.name:'-'}}</td>
                    <td class="title">社会信用代码</td>
                    <td>{{guaranteeModel.owner?guaranteeModel.owner.businessLicense:'-'}}</td>
                  </tr>
                  <tr>
                    <td class="title">法人</td>
                    <td>{{guaranteeModel.owner?guaranteeModel.owner.legalPersonName:'-'}}</td>
                    <td class="title">营业地址</td>
                    <td>{{guaranteeModel.owner?guaranteeModel.owner.address:'-'}}</td>
                    <td class="title">所在地</td>
                    <td>{{guaranteeModel.owner?guaranteeModel.owner.regCity:'-'}}</td>
                  </tr>
                  <tr>
                    <td class="title">联系人</td>
                    <td>{{guaranteeModel.owner?guaranteeModel.owner.contact:'-'}}</td>
                    <td class="title">联系电话</td>
                    <td>{{guaranteeModel.owner?guaranteeModel.owner.contactTel:'-'}}</td>
                    <td class="title">电子邮件</td>
                    <td>{{guaranteeModel.owner?guaranteeModel.owner.email:'-'}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="padding-top-20"></div>
              <Divider>承包商详情</Divider>
              <table class="brief-table">
                <tbody>
                  <tr>
                    <td class="title">总承包商名称</td>
                    <td colspan="3">{{guaranteeModel.contractor?guaranteeModel.contractor.name:'-'}}</td>
                    <td class="title">社会信用代码</td>
                    <td>{{guaranteeModel.contractor?guaranteeModel.contractor.businessLicense:'-'}}</td>
                  </tr>
                  <tr>
                    <td class="title">总承包合同备案号</td>
                    <td>{{guaranteeModel.contractorContractNo}}</td>
                    <td class="title">法人</td>
                    <td>{{guaranteeModel.contractor?guaranteeModel.contractor.legalPersonName:'-'}}</td>
                    <td class="title">所在地</td>
                    <td>{{guaranteeModel.contractor?guaranteeModel.contractor.regCity:'-'}}</td>
                  </tr>
                  <tr>
                    <td class="title">营业地址</td>
                    <td>{{guaranteeModel.contractor?guaranteeModel.contractor.address:'-'}}</td>
                    <td class="title">联系人</td>
                    <td>{{guaranteeModel.contractor?guaranteeModel.contractor.contact:'-'}}</td>
                    <td class="title">联系电话</td>
                    <td>{{guaranteeModel.contractor?guaranteeModel.contractor.contactTel:'-'}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="padding-top-20"></div>
              <Divider>监理企业详情</Divider>
              <table class="brief-table">
                <tbody>
                  <tr>
                    <td class="title">监理企业名称</td>
                    <td colspan="3">{{guaranteeModel.supervisory?guaranteeModel.supervisory.name:'-'}}</td>
                    <td class="title">社会信用代码</td>
                    <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.businessLicense:'-'}}</td>
                  </tr>
                  <tr>
                    <td class="title">监理合同备案号</td>
                    <td>{{guaranteeModel.supervisoryContractNo}}</td>
                    <td class="title">法人</td>
                    <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.legalPersonName:'-'}}</td>
                    <td class="title">所在地</td>
                    <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.regCity:'-'}}</td>
                  </tr>
                  <tr>
                    <td class="title">营业地址</td>
                    <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.address:'-'}}</td>
                    <td class="title">联系人</td>
                    <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.contact:'-'}}</td>
                    <td class="title">联系电话</td>
                    <td>{{guaranteeModel.supervisory?guaranteeModel.supervisory.contactTel:'-'}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="padding-top-20"></div>
              <Divider>劳务分包详情</Divider>
              <table class="brief-table">
                <tbody>
                  <tr>
                    <td class="title">劳务分包负责人</td>
                    <td>{{guaranteeModel.distributorIncharge}}</td>
                    <td class="title">身份证号</td>
                    <td>{{guaranteeModel.distributorInchargeId}}</td>
                    <td class="title">劳务分包合同备案号</td>
                    <td>{{guaranteeModel.distributorContractNo}}</td>
                  </tr>
                  <tr>
                    <td class="title">联系人</td>
                    <td>{{guaranteeModel.distributorContact}}</td>
                    <td class="title">联系电话</td>
                    <td>{{guaranteeModel.distributorTel}}</td>
                    <td class="title"></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </TabPane>
          </Tabs>
        </div>
        <div class="padding-top-20"></div>
        <div class="padding-top-20"></div>
      </i-col>
    </Row>
    <Footer v-if="showHeader" style="text-align:center" />
  </div>
</template>

<script>
import Api from './../../api/Api.js'
import Footer from '@/components/Footer.vue'
export default {
  name: 'verify',
  props: {
  },
  components: {
    Footer
  },
  data () {
    return {
      showHeader: false,
      loading: false,
      code: '',
      showErr: false,
      errMsg: '',
      guaranteeModel: null,
      prjTypes: [],
      verifyMethod: 'code'
    }
  },
  watch: {
  },
  computed: {
    totalGuaAmount () {
      let mainAmount = this.guaranteeModel.amount
      let jointAmount = 0
      this.guaranteeModel.jointGuarantors.forEach((j) => {
        jointAmount += j.amount
      })
      return mainAmount + jointAmount
    }
  },
  mounted () {
    if (this.$route.query && (this.$route.query.verifycode || this.$route.query.guanumber)) {
      if (this.$route.query.guanumber) {
        this.verifyMethod = 'orderNumber'
        this.code = this.$route.query.guanumber
      } else {
        this.verifyMethod = 'code'
        this.code = this.$route.query.verifycode
      }
      this.verify()
    }
    let verifyObj = document.querySelector('#app > .verify')
    if (verifyObj) {
      this.showHeader = true
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    verify () {
      this.loading = true
      this.showErr = false
      this.errMsg = ''
      this.guaranteeModel = null
      return new Promise((resolve, reject) => {
        if (this.code) {
          this.code = this.code.replace(/-/g, '')
        }
        if (this.verifyMethod === 'code') {
          Api.Guarantee.verifyByCode(this.code).then((res) => {
            this.loading = false
            if (res.orderNumber) {
              this.guaranteeModel = res
              // this.$router.push('/guarantees/detail/' + res.orderNumber)
            }
            console.log(res)
            resolve(res)
          }).catch(err => {
            this.loading = false
            this.showErr = true
            this.errMsg = '验证失败!' + err.message
            this.$Message.error('验证失败!' + err.message)
            reject(err)
          })
        } else {
          Api.Guarantee.verifyByOrderNumber(this.code).then((res) => {
            this.loading = false
            if (res.orderNumber) {
              this.guaranteeModel = res
              // this.$router.push('/guarantees/detail/' + res.orderNumber)
            }
            console.log(res)
            resolve(res)
          }).catch(err => {
            this.loading = false
            this.showErr = true
            this.errMsg = '验证失败!' + err.message
            this.$Message.error('验证失败!' + err.message)
            reject(err)
          })
        }
      })
    },
    getPrjType (type) {
      let prjType
      if (!this.prjTypes.length) {
        this.initPrjTypes().then((types) => {
          prjType = types.find(o => o.tid === parseInt(type))
        })
      } else {
        prjType = this.prjTypes.find(o => o.tid === parseInt(type))
      }
      if (prjType) {
        let prjTypeCur = [prjType.prjType]
        if (prjType.parentNode) {
          let parentNode = this.prjTypes.find(o => o.tid === prjType.parentNode)
          prjTypeCur.splice(0, 0, parentNode.prjType)
        }
        return prjTypeCur
      } else {
        return []
      }
    },
    async initPrjTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Project.getPrjTypes().then(res => {
          this.prjTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  background: linear-gradient(45deg, #3d3294, #3098ff);
  padding: 0;
}
.top-bar {
  background: transparent;
  padding: 0;
}
.top-bar-search {
  display: inline-block;
  width: 100px;
  margin-right: 20px;
  transition: all linear .3s;
  &.expand {
    width: 300px;
  }
}
.layout-logo {
  height: 50px;
  // background: #5b6270;
  color: #fefefe;
  text-align: center;
  border-radius: 3px;
  float: left;
  position: relative;
  top: 5px;
  margin-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  .site-name-area {
    line-height: initial;
    text-align: left;
  }
}
.layout-nav{
  margin: 0 auto;
  margin-right: 20px;
  display: inline-block;
}
</style>
